export type TreeviewId = string | number;

/** A node as the API hands it over: categories nest via `children`, feature
 * aggregations via `buckets`. */
export interface TreeviewSource {
  id: TreeviewId;
  name: string;
  children?: TreeviewSource[];
  buckets?: TreeviewSource[];
}

export const childrenOf = (node: TreeviewSource): TreeviewSource[] =>
  node.children ?? node.buckets ?? [];

/** Every leaf below `node`, or `node` itself when it has no children. */
export const leavesOf = (node: TreeviewSource): TreeviewId[] => {
  const children = childrenOf(node);
  return children.length ? children.flatMap(leavesOf) : [node.id];
};

export const flatten = (nodes: TreeviewSource[]): TreeviewSource[] =>
  nodes.flatMap((node) => [node, ...flatten(childrenOf(node))]);
